import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingBottomImageLarge: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 2.5h16V0H0zM0 7h12V4.5H0zm16 2H0v7h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingBottomImageLarge
